import React from "react"
import { Workload } from "../../types/graphql-types"
import { graphql } from "gatsby"

export const workloadQuery = graphql`
  fragment Workload on Workload {
    amount
    note
    unit
  }
`

interface IWorkload {
  workload?: Workload
}

export const WorkloadItem: React.FC<IWorkload> = ({ workload }) =>
  workload ? (
    <span class="inline font-medium">
      {" "}
      ({workload.amount}&nbsp;{workload.unit})
    </span>
  ) : (
    <>{""}</>
  )
